/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { FormattedNumber } from 'react-intl';
import axios from 'axios';
import { getAuthToken } from 'Api';
import { connect } from 'react-redux';
import * as actions from 'Actions';
import classnames from 'classnames';
import Modal from 'Utils/Modal';
import CurrencyInput from 'Utils/CurrencyInput';
import { toNumber } from 'HelperFunctions/general';
import validations from 'HelperFunctions/validations';
import Radio from 'Utils/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CreditCardForm from 'Components/profile/creditCards/CreditCardForm';
import PropayBankForm from 'Components/profile/bankAccounts/PropayBankForm';
import WorldpayBankForm from 'Components/profile/bankAccounts/WorldpayBankForm';
import StandardSelectField from 'Utils/redux_form_inputs/StandardSelectField';
import { MakeAPayment } from 'Utils/SvgIcons';
import PlaidLink from 'Utils/login/PlaidLink';
import GrailpayLink from 'Utils/login/GrailpayLink';
import converter from 'json-style-converter/es5';
import ScrollArea from 'Utils/react-scrollbar';
import CurrencyLabel from 'Utils/CurrencyLabel';
import { Close } from '../utils/SvgIcons';

class ConnectPaymentBox extends React.Component {
  state = {
    paymentSelection: 'credit_card',
    open: false,
    successOpen: false,
    successRefundOpen: false,
    errors: {},
    loading: false,
    billingStatus: '',
    transaction: {
      amount: '',
      payment_type: 'credit_card',
      payment_date: new Date(),
      card_token: '',
      bank_token: '',
      check_number: '',
    },
    removedBankAccountIds: [],
    initialBillingAddress: null,
    new_card: null,
    new_bank: null,
    amountType: '',
    customAmount: '',
    linkToken: null,
  };

  componentDidMount() {
    const { rental } = this.props;
    let amountType;
    if (!rental.hasDeposit) {
      amountType = 'amountDue';
    } else {
      amountType = rental.amountRemaining > 0 ? 'amountRemaining' : '';
    }
    this.setState(
      {
        amountType,
        customAmount: this.getPaymentAmount(amountType),
      },
      this.fetchLinkToken
    );
  }

  fetchLinkToken = () => {
    const { customer } = this.props;
    axios
      .post(`${process.env.REACT_APP_API_DOMAIN}/api/create_link_token`, {
        customer_id: customer.id,
      })
      .then((response) => {
        this.setState({ linkToken: response.data.link_token });
      })
      .catch((error) => {
        console.error('Failed to fetch link token:', error);
      });
  };

  componentWillReceiveProps(nextProps) {
    const { rental } = nextProps;
    if (
      rental.hasDeposit !== this.props.rental.hasDeposit ||
      rental.amountRemaining !== this.props.rental.amountRemaining
    ) {
      let amountType;
      if (!rental.hasDeposit) {
        amountType = 'amountDue';
      } else {
        amountType = rental.amountRemaining > 0 ? 'amountRemaining' : '';
      }
      this.setState({
        amountType,
        customAmount: this.getPaymentAmount(amountType),
      });
    }
  }

  handleRemoveBank = (bankAccountId) => {
    const { customer } = this.props;
    axios
      .delete(
        `${process.env.REACT_APP_API_DOMAIN}/api/portal/bank_accounts/${bankAccountId}`,
        { headers: getAuthToken() }
      )
      .then(() => {
        // mark it removed in local state
        this.setState((state) => ({
          removedBankAccountIds: [
            ...state.removedBankAccountIds,
            bankAccountId,
          ],
        }));
      })
      .catch((err) => {
        console.error('Failed to remove bank account:', err);
      });
  };

  validate = () => {
    const errors = {};
    const amountDue = this.props.rental.amountRemaining;
    const { paymentSelection, transaction, customAmount } = this.state;

    if (
      paymentSelection === 'credit_card' &&
      validations.required(transaction.card_token, true)
    ) {
      errors.body = 'Please select a credit card.';
    }
    if (
      paymentSelection === 'bank' &&
      validations.required(transaction.bank_token, true)
    ) {
      errors.body = 'Please select a bank account.';
    }
    if (customAmount > amountDue || customAmount < 0) {
      errors.body = 'The Custom Amount you entered is invalid!';
    }

    return errors;
  };

  isOnlyLetters = (str) => {
    let strWithoutSpaces = str.replace(/\s/g, '');
    return /^[a-zA-Z]+$/.test(strWithoutSpaces);
  };

  isOnlyNumbers = (str) => {
    let strWithoutSpaces = str.replace(/\s/g, '');
    return /^\d+$/.test(strWithoutSpaces);
  };

  validateMerchantAccount = (location, paymentProcessor) => {
    const error = {};
    if (location.isOnTrial) {
      error.merchantAccount = 'Location is on trial and cannot accept payments';
    }
    if (paymentProcessor === 'stripe' && !location.hasStripeAuthentication) {
      error.merchantAccount = 'Merchant account is not setup for Stripe';
    }
    if (paymentProcessor === 'propay' && !location.hasPropayAuthentication) {
      error.merchantAccount = 'Merchant account is not setup for Propay';
    }
    if (
      (paymentProcessor === 'worldpay' || paymentProcessor === 'launchpay') &&
      !location.hasWorldpayAuthentication
    ) {
      error.merchantAccount = 'Merchant account is not setup.';
    }
    return error;
  };

  validateTransactionAmountAndType = (transaction, amount) => {
    const error = {};
    const { payment_type } = transaction;
    const cardTypes = ['new_credit_card', 'credit_card'];
    const bankTypes = ['new_bank', 'bank'];
    if (amount <= 0) {
      error.noAmount = 'Charge amount must be greater than 0.';
    }
    if (cardTypes.includes(payment_type) && amount < 0.5) {
      error.amount = 'The minimum charge is $0.50';
    } else if (bankTypes.includes(payment_type) && amount < 1.5) {
      error.amount = 'The minimum bank charge is $1.50.';
    }
    return error;
  };

  validateNewCreditCard = (card) => {
    const errors = {};
    let today = new Date();
    let selectedMonth = document.getElementById(
      'credit_card_month_select_list'
    )?.value;
    let selectedYear = document.getElementById(
      'credit_card_year_select_list'
    )?.value;
    let expirationDate = new Date();
    expirationDate.setFullYear(selectedYear, selectedMonth, 0);
    if (expirationDate < today) {
      errors.expired = 'Card expiration dates are invalid.';
    }
    if (validations.creditcard(card.number)) {
      if (!card.number) {
        errors.number = 'Card number cannot be blank.';
      } else {
        errors.number = 'Card number is not valid.';
      }
    }
    if (!this.isOnlyNumbers(card.number)) {
      errors.number = 'Card number must contain only numbers.';
    }
    if (!card.cvc) {
      errors.cvc = 'CVC security code is invalid.';
    }
    if (!card.country) {
      errors.country = 'Country cannot be blank.';
    }
    const validateField = (field, errorMessage, errorKey) => {
      if (card.country !== 'INT' && !field) {
        errors[errorKey] = errorMessage;
      }
    };
    validateField(card.city, 'City cannot be blank.', 'city');
    validateField(
      card.street_address1,
      'Billing Address cannot be blank.',
      'address'
    );
    validateField(card.locale, 'Province / State cannot be blank.', 'locale');
    validateField(card.postal_code, 'Zip code cannot be blank.', 'zipcode');
    if (!card.name) {
      errors.name = 'Cardholder name cannot be blank.';
    }
    if (!this.isOnlyLetters(card.name)) {
      errors.name = 'Cardholder name must be letters only.';
    }
    return errors;
  };

  validateNewBank = (newBank) => {
    // Skip Propay/Worldpay bank validation when using GrailPay
    if (this.props.location.hasGrailpayEnabled) {
      return {};
    }

    const errors = {};
    const { account_number, bank_number, first_name, last_name } = newBank;
    if (!account_number) {
      errors.accountNumber = 'Account number cannot be blank.';
    }
    if (!this.isOnlyNumbers(account_number)) {
      errors.accountNumber = 'Account number must contain only numbers.';
    }
    if (!bank_number) {
      errors.bankNumber = 'Routing number cannot be blank.';
    }
    if (!this.isOnlyNumbers(bank_number)) {
      errors.notNumber = 'Routing number must contain only numbers.';
    }
    if (bank_number.length !== 9) {
      errors.bankNumber = 'Routing number must be 9 digits.';
    }
    if (!this.isOnlyLetters(first_name) || !this.isOnlyLetters(last_name)) {
      errors.accountName = 'Account name must be letters only.';
    }
    return errors;
  };

  validatePayments = (transaction, location, paymentProcessor) => {
    const error = {};
    const { payment_type } = transaction;
    const { hasWorldpayAuthentication } = location;
    const types = ['credit_card', 'new_credit_card'];
    if (
      types.includes(payment_type) &&
      !hasWorldpayAuthentication &&
      (paymentProcessor === 'worldpay' || paymentProcessor === 'launchpay')
    ) {
      error.paymentError = `This business isn't ready to accept ${paymentProcessor} payments.`;
    }
    if (payment_type === 'new_bank' && !hasWorldpayAuthentication) {
      error.paymentError = "This business isn't ready to accept bank payments.";
    }
    return error;
  };

  validateCardType = (cardType) => {
    const error = {};
    if (cardType === 'Select Card Type') {
      error.cardType = 'A card type must be selected.';
    }
    return error;
  };

  validateCardSelection = (cardSelected) => {
    const error = {};
    if (cardSelected === 'Select a Credit Card') {
      error.cardSelected = 'Please select a card.';
    }
    return error;
  };

  validateBankSelection = (bankSelected) => {
    const error = {};
    if (bankSelected === 'Select a Bank Account') {
      error.bankSelected = 'Please select a bank account';
    }
    return error;
  };

  validateBankType = (paymentMethodType, checkType, companyName) => {
    const error = {};
    if (paymentMethodType === 'Select Payment Method Type') {
      error.bankType = 'You must select an account type.';
    }
    if (checkType === 'Check Type') {
      error.checkType = 'You must select a check type';
    }
    if (checkType === 'Business' && !companyName) {
      error.companyName = 'Please enter a Company name';
    }
    return error;
  };

  buildRailsObject = () => {
    const { location, customer, rental } = this.props;
    const { transaction, new_card, new_bank, amountType } = this.state;

    let payment_type;
    if (transaction.payment_type === 'credit_card') {
      payment_type =
        transaction.card_token === 'new_credit_card'
          ? 'new_credit_card'
          : 'credit_card';
    } else {
      payment_type = transaction.bank_token.startsWith('new_bank')
        ? 'new_bank'
        : 'bank';
    }

    const newTransaction = {
      ...transaction,
      customer_id: customer.id,
      amount: this.getPaymentAmount(amountType),
      payment_source: 'cp',
      payment_type,
    };

    return {
      location_id: location.id,
      transaction: newTransaction,
      billing_note: {
        author_name: `${customer.firstName} ${customer.lastName}`,
        message: 'From Storefront',
        note_type: 'Payment',
      },
      new_card,
      new_bank,
      send_receipt: true,
    };
  };

  handleSubmitNewCreditCard = (values) => {
    const errors = this.validateNewCreditCard(values);
    if (Object.keys(errors).length > 0) {
      this.props.setErrors(errors);
    } else {
      this.setState({ new_card: values }, this.handleSubmit);
    }
  };

  handleSubmitNewPropayBank = (values) => {
    this.setState(
      {
        new_bank: values,
        transaction: {
          ...this.state.transaction,
          bank_token: 'new_bank_manual',
        },
      },
      this.handleSubmit
    );
  };

  handleSubmitNewBank = (token, metadata) => {
    // Plaid
    const new_bank = { token, account_id: metadata.account_id };
    this.setState(
      {
        new_bank,
        transaction: { ...this.state.transaction, bank_token: 'new_bank' },
      },
      this.handleSubmit
    );
  };

  handleSubmitNewBankGrailpay = (rawData) => {
    if (!Array.isArray(rawData) || rawData.length === 0) {
      console.warn('No accounts returned from GrailPay');
      return;
    }
    const acct = rawData[0];
    const new_bank = {
      token: acct.user_uuid,
      account_uuid: acct.account_uuid,
      account_id: acct.account_id,
      account_number: acct.account_number,
      routing_number: acct.routing_number,
      account_status: acct.account_status,
      account_type: acct.account_type,
      name: acct.name,
      provider_name: acct.provider_name,
      aggregator_type: acct.aggregator_type,
      user_uuid: acct.user_uuid,
      vendor_id: acct.vendor_id,
      created_at: acct.created_at,
      updated_at: acct.updated_at,
    };
    this.setState(
      {
        new_bank,
        transaction: { ...this.state.transaction, bank_token: 'new_bank_sdk' },
      },
      this.handleSubmit
    );
  };

  handleSubmit = () => {
    const { new_card, new_bank, transaction, customAmount, paymentSelection } =
      this.state;
    const {
      rental,
      location,
      openLoadingSpinner,
      closeLoadingSpinner,
      onPaymentSuccess,
    } = this.props;

    const errors = {
      ...this.validate(),
      ...this.validateMerchantAccount(location, rental.paymentProcessor),
      ...this.validateTransactionAmountAndType(transaction, customAmount),
      ...this.validatePayments(transaction, location, rental.paymentProcessor),
    };

    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      this.props.setErrors(errors);
      return;
    }

    openLoadingSpinner(
      'Processing payment... Please do not refresh or navigate away from this page.'
    );
    axios
      .post(
        `${process.env.REACT_APP_API_DOMAIN}/api/portal/rentals/${rental.token}/transactions`,
        this.buildRailsObject(),
        { headers: getAuthToken() }
      )
      .then((response) => {
        closeLoadingSpinner();
        onPaymentSuccess(response.data.transaction);
        this.setState({
          open: false,
          transaction: {
            amount: '',
            payment_type: 'new_credit_card',
            payment_date: new Date(),
            card_token: '',
            bank_token: '',
            check_number: '',
          },
          new_card: null,
          new_bank: null,
          errors: {},
        });
      })
      .catch((error) => {
        closeLoadingSpinner();
        const respErrors = error.response?.data || {};
        this.props.setErrors(respErrors);
        this.setState({ errors: respErrors });
      });
  };

  handleSuccessClose = () => {
    this.setState({ successOpen: false });
  };

  handleTransactionChange = (event) => {
    const { name, value } = event.target;
    this.setState({
      transaction: { ...this.state.transaction, [name]: value },
    });
  };

  handlePaymentAmountChange = (event) => {
    this.setState({ customAmount: event.target.value });
  };

  handlePaymentTypeChange = (event) => {
    const value = event.target.value;
    this.setState({
      paymentSelection: value,
      transaction: {
        ...this.state.transaction,
        payment_type: value,
        card_token: '',
        // if they switched to bank, preselect "new_bank"
        bank_token: value === 'bank' ? 'new_bank' : '',
      },
    });
  };


  handleAmountTypeChange = (event) => {
    const newAmountType = event.target.value;
    this.setState({
      amountType: newAmountType,
      customAmount: this.getPaymentAmount(newAmountType),
    });
  };

  getPaymentAmount = (amountType) => {
    const { rental } = this.props;
    const amountDue = rental.hasDeposit
      ? 0
      : Number(rental.minimumDeposit) - Number(rental.paymentBalance);
    switch (amountType) {
      case 'amountDue':
        return amountDue;
      case 'amountRemaining':
        return rental.amountRemaining;
      case 'custom':
        return this.state.customAmount;
      default:
        return 0;
    }
  };

  renderCreditCardFee = () => {
    const { creditCardPercent, rental } = this.props;
    const { paymentSelection, transaction } = this.state;
    const percent = creditCardPercent / 100.0;

    if (
      paymentSelection === 'credit_card' &&
      percent > 0 &&
      rental.location.chargeCreditCardFee
    ) {
      if (transaction.amount) {
        return (
          <p>
            You will be charged{' '}
            <CurrencyLabel value={Number(transaction.amount) * percent} /> for
            credit card fees.
          </p>
        );
      } else {
        return (
          <p>
            You will be charged{' '}
            <FormattedNumber
              value={percent}
              style='percent'
              minimumFractionDigits={2}
              minimumSignificantDigits={3}
            />{' '}
            for credit card fees.
          </p>
        );
      }
    }
    return null;
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: toNumber(value) });
  };

  copyAddress = (event, isChecked) => {
    if (isChecked) {
      const { customer } = this.props;
      const customerAddress = {
        streetAddress1: customer.streetAddress1,
        streetAddress2: customer.streetAddress2,
        city: customer.city,
        postalCode: customer.postalCode,
        locale: customer.locale,
        country: customer.country,
      };
      this.setState({
        initialBillingAddress: converter.camelToSnakeCase(customerAddress),
      });
    }
  };

  isPropayInUSA = (rental, location) =>
    rental.paymentProcessor === 'propay' && location.propayCountry === 'USA';

  render() {
    const {
      errors,
      paymentSelection,
      initialBillingAddress,
      customAmount,
      amountType,
      transaction,
      linkToken,
      removedBankAccountIds,
    } = this.state;
    const { location, customer, rental } = this.props;

    const savedBankAccounts = customer.bankAccounts
      .filter((ba) => !removedBankAccountIds.includes(ba.id))
      .filter((ba) => {
        const rentalPaymentProcessor = rental.paymentProcessor;
        const bankAccountPaymentProcessor = ba.paymentProcessor;

        // 1. Stripe rentals only ever get Stripe Bank Accounts
        if (rentalPaymentProcessor === 'stripe') {
          return bankAccountPaymentProcessor === 'stripe';
        }

        // 2. Launchpay rentals...
        if (rentalPaymentProcessor === 'launchpay') {
          // 2a. …before Grailpay-switch keep only Launchpay Bank Accounts
          if (!location.hasGrailpayEnabled) {
            return bankAccountPaymentProcessor === 'launchpay';
          }
          // 2b. …after Grailpay-switch keep only Grailpay Bank Accounts
          return bankAccountPaymentProcessor === 'grailpay';
        }

        // 3. Everything else: no Bank Accounts
        return false;
      });

    return (
      <section>
        <div className='summary'>
          <MakeAPayment />
          <h4>{rental.locationName}</h4>
          <div className='billingDetails'>
            {!rental.hasDeposit && rental.minimumDeposit !== '' && (
              <div>
                <label>Minimum Deposit</label>
                <CurrencyLabel
                  value={
                    Number(rental.minimumDeposit) -
                    Number(rental.paymentBalance)
                  }
                />
              </div>
            )}
            <div>
              <label>Amount Remaining</label>
              <CurrencyLabel value={rental.amountRemaining} />
            </div>
          </div>
        </div>

        <ScrollArea speed={0.8} horizontal={false}>
          <div className='details'>
            {/* Amount Selection */}
            <div className='fields amount'>
              <label>Payment Amount</label>
              <RadioGroup
                name='amountType'
                className='radioList'
                value={amountType}
                onChange={this.handleAmountTypeChange}
              >
                <FormControlLabel
                  label='Amount Due'
                  value='amountRemaining'
                  control={<Radio />}
                />
                <FormControlLabel
                  label='Minimum Deposit to Reserve'
                  value='amountDue'
                  control={<Radio />}
                />
                <FormControlLabel
                  label='Custom Amount'
                  value='custom'
                  control={<Radio />}
                />
              </RadioGroup>
              <strong>
                <CurrencyLabel
                  value={this.getPaymentAmount('amountRemaining')}
                />
              </strong>
              <strong>
                <CurrencyLabel value={this.getPaymentAmount('amountDue')} />
              </strong>
              <CurrencyInput
                name='customAmount'
                type='text'
                placeholder='0.00'
                className={classnames({ med: true, error: errors.amount })}
                value={customAmount}
                onChange={this.handleChange}
              />
            </div>

            {/* Method of Payment */}
            <div className='fields'>
              <label>Method of Payment</label>
              <RadioGroup
                name='paymentType'
                className='radioList'
                onChange={this.handlePaymentTypeChange}
                value={paymentSelection}
              >
                <FormControlLabel
                  value='credit_card'
                  control={<Radio />}
                  label='Credit Card'
                />
                {(rental.paymentProcessor === 'stripe' || location.hasGrailpayEnabled) && (
                  <FormControlLabel
                    value='bank'
                    control={<Radio />}
                    label='Bank Account'
                  />
                )}
              </RadioGroup>
            </div>

            {/* Pay With */}
            <div className='fields'>
              <label>Pay Using</label>
              {paymentSelection === 'credit_card' && (
                <StandardSelectField
                  meta={{}}
                  input={{
                    name: 'card_token',
                    value: transaction.card_token,
                    onChange: this.handleTransactionChange,
                  }}
                >
                  <option>Select a Credit Card</option>
                  <option value='new_credit_card'>New Credit Card</option>
                  {customer.creditCards
                    .filter(
                      (cc) =>
                        (rental.paymentProcessor === 'launchpay' &&
                          cc.paymentProcessor === 'worldpay') ||
                        cc.paymentProcessor === rental.paymentProcessor
                    )
                    .map((credit_card) => (
                      <option key={credit_card.id} value={credit_card.token}>
                        {credit_card.name}
                      </option>
                    ))}
                </StandardSelectField>
              )}
              {transaction.card_token === 'new_credit_card' && (
                <CreditCardForm
                  onSubmit={this.handleSubmitNewCreditCard}
                  copyAddress={this.copyAddress}
                  initialBillingAddress={initialBillingAddress}
                  hideCopy={customer.streetAddress1 === null}
                  type='checkout'
                  withPaymentType={['propay', 'worldpay', 'launchpay'].includes(
                    rental.paymentProcessor
                  )}
                  paymentProcessor={rental.paymentProcessor}
                />
              )}

              {paymentSelection === 'bank' && (
                <>
                  <StandardSelectField
                    meta={{}}
                    input={{
                      name: 'bank_token',
                      value: transaction.bank_token,
                      onChange: this.handleTransactionChange,
                    }}
                  >
                    {location.hasGrailpayEnabled ? (
                      <>
                        <option value='select_a_bank'>Select a Bank</option>
                        <option value='new_bank_sdk'>Bank Account Online Credentials</option>
                        <option value='new_bank_manual'>
                          Bank Routing and Account Number
                        </option>
                        {savedBankAccounts.map((bankAccount) => (
                          <option
                            key={bankAccount.id}
                            value={bankAccount.token}
                          >
                            ****{bankAccount.bankInfo.last4}
                          </option>
                        ))}
                      </>
                    ) : (
                      <>
                        <option value='new_bank'>New Bank Account</option>
                      </>
                    )}
                  </StandardSelectField>

                  {location.hasGrailpayEnabled &&
                    savedBankAccounts.length > 0 && (
                      <details className='saved-accounts-dropdown'>
                        <summary>
                          Manage Saved Bank Accounts ({savedBankAccounts.length}
                          )
                        </summary>
                        <ul className='saved-account-list'>
                          {savedBankAccounts.map((ba) => (
                            <li key={ba.id} className='saved-account-item'>
                              <span>****{ba.bankInfo.last4}</span>
                              <div
                                role='button'
                                onClick={() => this.handleRemoveBank(ba.id)}
                              >
                                <Close />
                              </div>
                            </li>
                          ))}
                        </ul>
                      </details>
                    )}
                </>
              )}

              {/* Stripe/ Plaid Bank Link */}
              {paymentSelection === 'bank' &&
                transaction.bank_token === 'new_bank' &&
                rental.paymentProcessor === 'stripe' &&
                linkToken && (
                  <PlaidLink
                    linkToken={linkToken}
                    clientName={rental.locationName}
                    onSuccess={this.handleSubmitNewBank}
                    selectAccount={true}
                    className='btn full'
                    buttonText='Pay with Bank Account'
                  />
                )}

              {/* GrailPay SDK */}
              {paymentSelection === 'bank' &&
                transaction.bank_token === 'new_bank_sdk' &&
                (rental.paymentProcessor === 'worldpay' ||
                  rental.paymentProcessor === 'launchpay') && (
                  <GrailpayLink
                    env={process.env.REACT_APP_GRAILPAY_ENV}
                    token={process.env.REACT_APP_GRAILPAY_PUBLIC_BANKLINK_KEY}
                    vendorId={location.worldpayAuthentication?.acceptorId}
                    billingProcessorMid={location.worldpayAuthentication?.gatewayMid}
                    role='business'
                    timeout={30}
                    onBankConnected={this.handleSubmitNewBankGrailpay}
                    onError={(err) =>
                      this.setState({ errors: { widget: err.message } })
                    }
                    onExit={(info) =>
                      console.log('GrailPay widget closed:', info)
                    }
                    buttonText='Pay with Bank Account'
                    className='btn full'
                  />
                )}

              {/* Manual Worldpay/Propay Form */}
              {paymentSelection === 'bank' &&
                (transaction.bank_token === 'new_bank_manual' ||
                  (!location.hasGrailpayEnabled &&
                    transaction.bank_token === 'new_bank')) &&
                (rental.paymentProcessor === 'worldpay' ||
                  rental.paymentProcessor === 'launchpay') && (
                  <WorldpayBankForm
                    onSubmit={this.handleSubmitNewPropayBank}
                    type='checkout'
                  />
                )}

              {/* Submit Button for Saved Methods */}

              {((paymentSelection === 'credit_card' &&
                transaction.card_token !== 'new_credit_card') ||
                (paymentSelection === 'bank' &&
                  !['new_bank', 'new_bank_sdk', 'new_bank_manual', 'select_a_bank'].includes(
                    transaction.bank_token
                  ))) && (
                  <div className='actions'>
                    <input
                      type='submit'
                      value='Submit Payment'
                      onClick={this.handleSubmit}
                      className='btn full'
                    />
                  </div>
                )}
            </div>

            {this.renderCreditCardFee()}
          </div>
        </ScrollArea>

        <Modal
          open={this.state.successOpen}
          toggle={this.handleSuccessClose}
          title='Payment Confirmation'
          actions={[
            <a className='btn full' onClick={this.handleSuccessClose}>
              Ok
            </a>,
          ]}
        >
          <p>Submitted payment was received</p>
        </Modal>
      </section>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const location = ownProps.location || state.locations.location;
  const customer = ownProps.customer || state.customer.customer;
  return {
    creditCardPercent: location.creditCardPercent,
    location,
    customer,
  };
};

export default connect(mapStateToProps, actions)(ConnectPaymentBox);
